
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .popup-re.q-ma-md
    .q-title.q-mb-md(v-if="params.title") {{params.title}}

    .flex.justify-center.items-end.q-mb-lg
      q-field
        q-input(
          v-model="re"
          type="number"
        )

    .row.reverse.reverse-wrap
      q-btn.q-mx-sm(
        flat
        v-close-overlay
      ) キャンセル

      q-btn.q-mx-sm(
        flat
        color="primary"
        @click="confirm"
      ) 確定

      slot(:params="params")

</template>

<script>
export default {

  data() {
    return {
      visible: false,

      re:      null,
      params:  {},
    }
  },

  methods: {
    show(re0, re1, params) {
      this.re     = re1 == null ? re0 : re1
      this.params = params

      this.visible = true
    },

    hide() {
      this.visible = false
    },

    confirm() {
      this.$emit('confirm', this.re, this.params)
    },
  },
}
</script>

<style lang="sass">
.popup-re
  width: 280px
</style>
